<template>
  <div class="header">
    <sf-header>
      <div class="header__container sf-cg sf-fr sf-pv-xs">
        <nuxt-link :to="mainLink" class="header__logo">
          <Logo/>
        </nuxt-link>
        <sf-lang-switch v-qa="'language_switcher'" class="header__switch sf-mr-s"/>
        <navigation :class="{ hidden: percent }" class="header__nav"/>
        <sf-progress
          v-if="percent"
          :value="Number(percent)"
          :total="totalSteps"
          :background-class="'sf-bg-secondary'"
          class="header__progress"
          slim/>
        <login class="header__login"/>
        <burger-menu class="header__mobile-menu sf-ml" @click="toggleDrawer"/>
      </div>
    </sf-header>

    <sf-drawer v-model="showDrawer" class="drawer">
      <sf-lang-switch class="drawer__switch"/>
      <profile-links class="drawer__profile"/>
      <navigation class="drawer__nav"/>
      <div class="drawer__contacts">
        <app-phone-link v-for="phone in phones" :key="phone" :phone-number="phone" class="sf-mb-xs"/>
        <app-email-link :email="$t('contacts-page.email-cc')"/>
      </div>
    </sf-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Logo from 'static/logo.svg';
import { WEB_ROUTES } from '~/utils/webConfig';

import Navigation from '~/components/header/navigation';
import ProfileLinks from '~/components/header/profile-links';
import Login from '~/components/header/login';
import BurgerMenu from '~/components/controls/burger';
import AppPhoneLink from '~/components/links/phone-link.vue';
import AppEmailLink from '~/components/links/email-link.vue';

export default {
  components: { Navigation, Login, BurgerMenu, ProfileLinks, Logo, AppPhoneLink, AppEmailLink },
  data: () => ({
    showDrawer: false,
  }),
  computed: {
    ...mapState('flow', ['percent', 'totalSteps', 'backgroundClass']),
    mainLink() {
      return this.localePath(WEB_ROUTES.MAIN);
    },
    phones() {
      return this.$t('contacts-page.phones');
    },
  },
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 6;
  background: map-get($colors, white);

  &__container {
    height: 80px;
    justify-content: space-between;
    align-items: center;
  }

  &__logo {
    display: block;
    max-width: 138px;
    width: 100%;
    max-height: 40px;
    height: 100%;
    margin-right: 26px;
  }

  &__switch {
    border-color: transparent;
    background: map-get($colors, background);
    box-shadow: none;

    @include not-desktop {
      display: none;
    }

    &::before {
      background-color: map-get($colors, secondary);
    }

    /deep/ &.primary .languages div:first-child {
      color: map-get($colors, gray-darker);
    }

    /deep/ &.secondary .languages div:nth-child(2) {
      color: map-get($colors, gray-darker);
    }
  }

  &__nav {
    @include not-desktop {
      display: none;
    }

    @include desktop {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      gap: 14px;
      margin-right: 24px;
    }

    &.hidden {
      @include desktop {
        display: none;
      }
    }
  }

  &__progress {
    margin: 0 auto;

    @include mobile {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    @include tablet {
      width: 500px;
    }

    @include tablet-only {
      @media (orientation: portrait) {
        width: 340px;
      }
    }
  }

  &__login {
    @include tablet-only {
      margin-left: auto;
    }
  }

  &__mobile-menu {
    @include desktop {
      display: none !important;
    }
  }
}

.drawer {
  &__switch {
    margin: 20px 30px 10px;
  }

  &__profile {
    padding: 20px 30px;
    border-bottom: 1px solid map-get($colors, border);
  }

  &__nav {
    padding: 20px 30px;
  }

  &__contacts {
    padding: 20px 30px;
    margin-top: auto;

    a {
      display: block;
      color: map-get($colors, primary);
    }
  }
}
</style>
